import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Paper, Grid, Typography } from '@material-ui/core';
import Card from 'components/Card';
import Loader from 'components/Loader';
import Select from 'components/Select';
import WarningMessage from 'components/WarningMessage';

import RemoveOS from './RemoveOS';
import VehicleExit from './VehicleExit';
import ChangeAccount from './ChangeAccount';
import ImportClients from './ImportClients';

import { loadFilters } from 'components/Filter/store/thunk';

import { actionType, adminActionType } from './resources';

export default function AdvancedConfigurations() {
  const dispatch = useDispatch();

  const { isAdminUser } = useSelector(state => state.profile.submit);

  const { userId } = useSelector(state => state.profile);
  const { establishmentId } = useSelector(state => state.businessInfo);
  const isUserAdmin = +isAdminUser == 1;

  const [action, setAction] = useState('remove_os');

  useEffect(() => {
    dispatch(loadFilters(userId, establishmentId));
  }, [establishmentId]);

  return(
    <Paper>
      <Card title="Configurações avançadas">
        <Grid container>
          <Grid xs={12}>
            <Loader isLoading={false}>
              <WarningMessage
                justifyContent="flex-start"
                message="Esta ação abaixo não pode ser desfeita. Ative as restrições de cada usuário restringindo acesso a essa configuração."
              />
              <Grid container style={{ marginTop: 30, marginBottom: 30 }}>
                <Grid xs={12}>
                  <Typography variant="subtitle2">
                    Escolha a configuração avançada que deseja executar
                  </Typography>
                </Grid>
                <Grid xs={12} md={6}>
                  <Select
                    name="advanced-configs-option"
                    label="Selecione uma configuração"
                    // options={isUserAdmin ? adminActionType : actionType}
                    options={actionType}
                    value={action}
                    onChange={event => setAction(event.target.value)}
                  />
                </Grid>
              </Grid>
              {(action == 'remove_os') && (
                <RemoveOS />
              )}
              {(action == 'force_vehicle_exit') && (
                <VehicleExit />
              )}
              {(action == 'change_account') && (
                <ChangeAccount />
              )}
              {(action == 'import_clients') && (
                <ImportClients />
              )}
            </Loader>
          </Grid>
        </Grid>
      </Card>
    </Paper>
  );
}